import { render, staticRenderFns } from "./commBaseCodeManageDetail.vue?vue&type=template&id=0a7b589c&scoped=true&"
import script from "./commBaseCodeManageDetail.vue?vue&type=script&lang=js&"
export * from "./commBaseCodeManageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b589c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a7b589c')) {
      api.createRecord('0a7b589c', component.options)
    } else {
      api.reload('0a7b589c', component.options)
    }
    module.hot.accept("./commBaseCodeManageDetail.vue?vue&type=template&id=0a7b589c&scoped=true&", function () {
      api.rerender('0a7b589c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/commBaseCodeManage/commBaseCodeManageDetail.vue"
export default component.exports